export const separateThousandsByComma = (x: number | string): string => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const getTotal = (currency: string, price: number, vague?: boolean) =>
  separateThousandsByComma(`${currency}${price / 100}${vague ? '' : ''}`);
